import * as React from "react";
import { cn } from "~/lib/utils";

/**
 * Ported from bouncieweb's `LandingPageComponents/LandingPageHeader` and
 * `LandingPageSubheader`. Faithful reproduction of the original responsive
 * typography (vw-based on mobile, fixed px at the sm/md breakpoints).
 *
 * Original breakpoint map (theme/mediaQueries):
 *   xsm 431px -> min-[431px]:  sm 640px -> sm:  md 768px -> md:
 */

/* eslint-disable i18next/no-literal-string */

/**
 * H1 twin of LandingPageHeaderH2. The original styled both identically and
 * picked the tag purely for SEO needs — the only difference is that the H2 also
 * carries a bottom margin.
 */
export function LandingPageHeaderH1({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<"h1">) {
  return (
    <h1
      className={cn(
        "font-display text-center font-extrabold leading-[1.1em]",
        "mt-16 text-[10vw] min-[431px]:text-[7vw] sm:text-[40px] md:text-[48px]",
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  );
}

export function LandingPageHeaderH2({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<"h2">) {
  return (
    <h2
      className={cn(
        "font-display text-center font-extrabold leading-[1.1em]",
        "mt-16 mb-3 text-[10vw] min-[431px]:text-[7vw] sm:text-[40px] md:text-[48px]",
        className,
      )}
      {...props}
    >
      {children}
    </h2>
  );
}

export function LandingPageSubheader({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<"p">) {
  return (
    <p
      className={cn(
        "mt-0 mb-12 text-center leading-[1.25]",
        "text-[4.5vw] min-[431px]:text-[4vw] sm:text-[20px] md:text-[24px]",
        className,
      )}
      {...props}
    >
      {children}
    </p>
  );
}
